import React from "react";
import { NavLink,useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import { useLanguage } from "@src/context/LanguageContext";
import secureStorage from "@src/config/encrypt";
import { toast } from "react-toastify";
//import { getMasterConfig } from '@src/store/slices/common';


const LOGO =  require('../styles/webroot/images/header_logo.png');

//import logo from "../styles/webroot/images/Logo.png"

const Navigation = (props:any) => {
    // const [isMount, setIsMount] = useState(false);
    // const [redirect, setRedirect] = useState(false);
    const [name, setName] = useState("");
    const navigate = useNavigate();
    const { setLanguage ,language,translations} = useLanguage();

    useEffect(() => {
        // setIsMount(true);
        let result = secureStorage.getItem("authUserInfo");

        if (!result) {
            //  setRedirect(true)
        } else {
            let userInfo = result.user_data;
            setName((userInfo && userInfo.name) || '');
        }

        // if (prevTranslationsRef.current !== translations) {
        //     dispatch(getMasterConfig());
        //     prevTranslationsRef.current = translations;
        // }
        // eslint-disable-next-line
    },[translations]);

    const logOutUser = async () => {
        let result = secureStorage.getItem("authUserInfo")
        if (result) {
            secureStorage.removeItem("authUserInfo")
            toast.success('LogOut Successfully')
            setTimeout(()=> { navigate('/login');  },100)
        }
    };


    const redirectToDashboard = () => {
         navigate('/dashboard');
        //HELPER.navigatePermssion(navigate);
    };
    
    return (
        <div className="container-fluid" >
            <div className="header-main">
                <div className="logo">
                <img src={LOGO} style={{cursor: 'pointer'}} alt="" onClick={() => redirectToDashboard()}/>
                </div>
                <div className="right-panel-naviganion menupanel">
                    <div className="nav">
                        <ul>
                             <li><NavLink to="/dashboard">{translations.Navigation?.['DASHBOARD'] || translations.commonMsg?.loading}</NavLink></li>
                              <li><NavLink to="/lead-list">{translations.Navigation?.['APPLICATION'] || translations.commonMsg?.loading}</NavLink></li>
                        </ul>
                        {/* <ul>
                            {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && (
                                <>
                                    <li><NavLink to="/lead-list">{translations.Navigation?.['Leads'] || translations.commonMsg?.loading}</NavLink></li>
                           
                                    <li className="dropdownmenu"><NavLink to="#">{translations.Navigation?.['More'] || translations.commonMsg?.loading}</NavLink>
                                        <ul className="submenu">
                                            <li><NavLink to="/rule-engine">{translations.Navigation?.['Rule Engine'] || translations.commonMsg?.loading}</NavLink> </li>
                                        </ul>
                                    </li> 
                                </>
                            )}
                        </ul> */}
                    </div>
                    

                    <div className="user-detail ">
                        <ul>

                            <li className="dropdownmenu"><NavLink to="#">
                                <span className="userarc">
                                    {name[0]?.toUpperCase()}
                                </span>
                                <div className="username">
                                    <span>{name}</span>
                                </div>
                            </NavLink>
                                <ul className="submenu">
                                    <li><NavLink to="#" onClick={logOutUser}>{translations.Navigation?.['LOGOUT'] || translations.commonMsg?.loading}</NavLink> </li>
                                </ul>
                            </li>

                        </ul>
                    </div>
                    <div className="language">
                        <ul>
                            <li className="dropdownmenu">
                                <NavLink to="#">
                                {language === 'en' ? 'EN' : 'ID'}
                                </NavLink>
                                <ul className="submenu">
                                <li>
                                    <NavLink
                                        to="#"
                                        onClick={language === 'en' ? undefined : () => setLanguage('en')}
                                        style={{
                                            cursor: language === 'en' ? 'not-allowed' : 'pointer',
                                            pointerEvents: language === 'en' ? 'none' : 'auto'
                                        }}
                                    >
                                        EN
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to="#"
                                        onClick={language === 'id' ? undefined : () => setLanguage('id')}
                                        style={{
                                            cursor: language === 'id' ? 'not-allowed' : 'pointer',
                                            pointerEvents: language === 'id' ? 'none' : 'auto'
                                        }}
                                    >
                                        ID
                                    </NavLink>
                                </li>
                            </ul>
                            </li>

                        </ul>
                    </div>
                
                </div>

            </div>

        </div >
    );
    
}



export default Navigation;